<template>
    <div class="container-wrap">
        <div class="section" v-for="(item,index) in sectionData" :key="index" :id="'section_' + index">
            <div class="img-container" :class="{'padding-container':item.smallBtn}">
                <img class="img" :src="item.url" :class="{'btn-style':item.type==='btn'}"
                    v-if="item.url"
                    @click="clickImage(item.type,item.button_name)"
                >
                <img src="https://s20.lgstatic.com/growth/activity/20211013/1634094147502.png" alt="" @click="JumpFn('了解详情')" class="hot-click" v-if="item.hotClick">
                <!-- 阶段 -->
                <div class="section-main" v-if="item.type==='tab'">
                    <div class="s-main">
                        <van-tabs v-model="active">
                            <van-tab v-for="(item, index) in stageList" :key="index" :title="item.stage" class="tb">
                                <div class="t-title">
                                    {{item.title}}
                                </div>
                                <img class="t-icon" src="https://s21.lgstatic.com/growth/activity/20210419/1618820076232.png">
                                <div class="target">
                                    <div class="title title1">
                                        <div class="tips"></div>
                                        <div class="text-title">本章讲师</div>
                                        <div v-if="item.details.length > 0" class="btn" @click="getTags(item)"></div>
                                    </div>
                                    <div class="content">
                                        <div class="content-list">
                                            <div class="icon white-bg"></div>
                                            <div class="text">{{item.teacher}}</div>
                                        </div>
                                    </div>
                                    <div class="title">
                                         <div class="tips"></div>
                                        <div class="text-title">学习目标</div>
                                    </div>
                                    <div class="content">
                                        <div v-for="(val,ind) in item.phaseTargetList" :key="ind" class="content-list">
                                            <div class="icon"></div>
                                            <div class="text">{{val}}</div>
                                        </div>
                                    </div>
                                    <div class="title title1">
                                         <div class="tips"></div>
                                        <div class="text-title">核心章节</div>
                                    </div>
                                    <div class="content">
                                        <div v-for="(val,ind) in item.skillsList" :key="ind" class="content-list">
                                            <div class="icon"></div>
                                            <div class="text">{{val}}</div>
                                        </div>
                                    </div>
                                    <div class="title title1">
                                        <div class="tips"></div>
                                        <div class="text-title">实战应用</div>
                                    </div>
                                    <div class="content">
                                        <div class="content-list">
                                            <div class="icon white-bg"></div>
                                            <div class="text">{{item.applycation}}</div>
                                        </div>
                                    </div>
                                </div>
                            </van-tab>
                        </van-tabs>

                        <div class="tips-tab">
                            * 具体课程内容以实际课程安排和进度为准
                        </div>
                    </div>
                </div>
                <div :class="'swiper-main'+item.dataType" v-if="item.type==='swiper'" class="swiper-main">
                    <div class="swiper-container current-wrap" :class="'current-wrap'+item.dataType">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide current-slider" v-for="(item,index) in swiperType(item.dataType)" :key="index">
                                <img :src="item">
                            </div>
                        </div>
                        <div class="swiper-pagination current-pagination" />
                    </div>
                 </div>
            </div>
            <div class="activityImg" v-if="activity.isShow">
                <img :src="activity.H5activeImg">
            </div>
        </div>

        <div class="ceiling-view" v-if="ceilingType">
            <div class="ceiling-tab" :class="{'ceiling-fixed':ceilingType}">
                <van-tabs v-model="activeTab" :swipe-threshold="4" @click="tabChange">
                    <van-tab v-for="(item, index) in tabList" :key="index" :title="item.stage" >
                    </van-tab>
                </van-tabs>
                <div class="box"></div>
            </div>
        </div>
        <button class="footer" @click="JumpFn('名额有限立即抢占')">
            <img class="img" :src="List.data.h5.footerImg">
            <img class="H5activityIcon" v-if="activity.isShow" :src="activity.H5icon">
            <div class="img-box">
                <img
                    class="img-btns"
                    src="https://s21.lgstatic.com/growth/activity/20210831/1630410757988.png"
                >
            </div>
            <FooterPoup
                :id="158"
                :isDcsj="false"
            />
        </button>
        <div :class="{'modal-container': true, active: modalVisable}" v-if="modalVisable">
            <div :class="{'layer': true, active: modalVisable}"/>
            <div class="modal">
                <div :class="{'modal-content': true, active: modalVisable && modalType == 'text', 'active-img': modalVisable && modalType != 'text'}">
                    <div class="close-container">
                        <div
                            class="close"
                            @click="closeModal"
                        />
                    </div>
                    <div v-if="modalType == 'text'">
                        <div class="title">
                            {{ moadlData.title }}
                            <div class="sub-title">
                                {{ moadlData.stage }}
                            </div>
                        </div>
                        <div class="content">
                            <div v-for="(val,inde) in moadlData.details" :key="inde">
                                <div class="content-title">
                                    {{val.t}}
                                </div>
                                <div class="content-desi" v-for="(i,its) in val.desc" :key="its">
                                    {{i}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="content-img">
                        <img :src="current" />
                    </div>
                </div>
            </div>
        </div>
        <RetainModal
            :visible="retainModalVisible"
            @removeHash="removeHash"
            pageId="1qzq"
        />
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import { Tab, Tabs } from 'vant';
import activity from '../../../common/activity';
Vue.use(Tab);
Vue.use(Tabs);
import List from './data.js'
import RetainModal from '../../../components/RetainModal/index.vue'
import { postIsBuyCourse } from '../../../service/api'
import { getEduAppVersion, isBiggerThanSpecifiedVersion } from '../../../uitl/getVersion'
import FooterPoup from '../../../components/FooterPoup/index.vue'

// ios
window.appBeforeGoBack = function () {
    window.location.hash = 'showModal'
    return 0
}
// android
if (isBiggerThanSpecifiedVersion(getEduAppVersion(), '2.3.4')) {
    window.appBeforeUnLoaded = function () {
        window.location.hash = 'showModal'
        return true
    }
}
export default {
    name: 'JavaJaGouShiH5',
    data() {
        return {
            activity,
            List,
            sectionData:[],
            swiperList1:[],
            swiperList2:[],
            swiperList3:[],
            ceilingType:false,//吸顶tab
            activeTab:0,
            modalVisable:false,
            moadlData:{},
            tabList:[],
            stageList:[],
            retainModalVisible: false,
            canShowModal: false
        };
    },
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        RetainModal,
        FooterPoup
    },
    computed: {
        swiperType() {
            return (type)=>{
                const swiperArr = [this.swiperList1, this.swiperList2, this.swiperList3]
                return swiperArr[type]
            }
        }
    },
    mounted() {
        let dataList = this.List.data;
        const {section, swiperList1,swiperList2,swiperList3} = dataList.h5;
        const {tabList, stageList} = dataList;
        this.sectionData = section;
        this.swiperList1 = swiperList1;
        this.swiperList2 = swiperList2;
         this.swiperList3 = swiperList3;
        this.tabList = tabList;
        this.stageList = stageList;
        this.watchHashChange()
        setTimeout(()=>{
          this.platTrack('h5pv', {
                page_id: 'u1uax',
            })
            this.swiperInit()
            this.renderSwipers()
            this.renderSwipers1()
            window.addEventListener('scroll', this.scrollTopFn)
        },500)
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollTopFn)
    },
    methods: {
        scrollTopFn() {
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            this.ceilingType = scroll > 370 ? true : false; //吸顶tab
            let arr = [
                "section_0",
                "section_8",
                "section_16",
                "section_22"
            ]
            arr.forEach((item,index) =>{
                if(document.getElementById(item).getBoundingClientRect().top < 100) {
                    this.activeTab = index
                }
            })
        },
        tabChange(val,title) {
            let arr = [
                "#section_0",
                "#section_8",
                "#section_16",
                "#section_22"
            ]

            this.$el.querySelector(arr[val]).scrollIntoView(true);
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            document.documentElement.scrollTop = scroll - 50
            document.body.scrollTop = scroll - 50
            this.eduPlatTrack('WebButtonClick', {
                'page_id': 'z1t6z',
                'button_name': title
            });
        },
        clickImage(type,name){
            if(type==='btn'){
                this.JumpFn(name);
            }
        },
        JumpFn(name) {
          if(name==='名额有限立即抢占'){
            this.platTrack('h5click', {
                page_id: 'u1uax',
                address_id: 'w1uaz'
            })
          }
            setTimeout(() => {
                handleJumpUrl(`b81a5c0d7dc94c3f88de261065ea56b3`);
            }, 500);
        },
        watchHashChange() {
            const that = this
            window.addEventListener('hashchange', function(e) {
                postIsBuyCourse().then(res => {
                    if (res.state == 1) {
                        if (res.content) {
                            window.lgBridge && window.lgBridge.request('close', {}, (res) => {});
                        } else {
                            that.canShowModal = !res.content
                            if (window.location.hash == '#showModal' && that.canShowModal) {
                                that.retainModalVisible = true
                            }
                        }
                    }
                })
            })
        },
        removeHash() {
            this.retainModalVisible = false
            this.canShowModal = false
            window.location.hash = ''
        },
        getTags(item){
            this.modalType = 'text';
            this.fixedBody();
            this.modalVisable = true;
            this.moadlData = item
        },
        closeModal(){
            this.looseBody();
            this.modalVisable = false;
        },
        fixedBody() {
            this.selfTop = document.body.scrollTop || document.documentElement.scrollTop;
            document.body.style.cssText += 'position:fixed;overflow: hidden;width:100%;height: auto;top: -' + this.selfTop + 'px';
        },
        looseBody() {
            var body = document.body;
            body.style.overflow = 'auto';
            body.style.height = 'auto';
            body.style.position = '';
            document.body.scrollTop = document.documentElement.scrollTop = parseInt(this.selfTop);
        },
        swiperInit() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 500,
                pagination: '.current-pagination',
                paginationType: 'bullets',
                paginationClickable: true,
                autoplayDisableOnInteraction: false,
                autoplay: 2800,
                slidesPerView: 'auto',
                centeredSlides: true,
                spaceBetween: 16,
            };

            this.$nextTick(() => {
                const swiper = new Swiper('.current-wrap', option);
            })

        },
        renderSwipers() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 500,
                pagination: '.current-pagination',
                paginationType: 'bullets',
                paginationClickable: true,
                autoplayDisableOnInteraction: false,
                autoplay: 2800,
                slidesPerView: 'auto',
                centeredSlides: true,
                // onClick(e){
                //     that.getSlide(e.realIndex)
                // }
            };
            const swiper = new Swiper('.current-wrap1', option);
        },
        renderSwipers1() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 500,
                pagination: '.current-pagination',
                paginationType: 'bullets',
                paginationClickable: true,
                autoplayDisableOnInteraction: false,
                autoplay: 2800,
                slidesPerView: 'auto',
                centeredSlides: true,
                // onClick(e){
                //     that.getSlide(e.realIndex)
                // }
            };
            const swiper = new Swiper('.current-wrap2', option);
        },
    }
};
</script>

<style lang='less' scoped>
.container-wrap {
    width: 100%;
    background: #F8F8F8;
    padding-bottom: 240px;
    .section {
        position: relative;
        width: 100%;
        background: #f8f8f8;
        .img {
            width: 100%;
            display: block;
        }
        .img-container{
            position: relative;
            .btn-style{
                position: absolute;
                text-align: center;
                bottom: 0;
                left: 50%;
                height: 88px;
                width: auto;
                transform: translate(-50%,-50%);
                z-index: 2;
            }
            .hot-click{
                width: 190px;
                height: 66px;
                position: absolute;
                bottom: 70px;
                left: 80px;
            }
        }
        .padding-container{
            .btn-style{
                height: 68px;
            }
        }
        .activityImg {
            position: absolute;
            z-index: 11;
            top: 0;
            right: 0;
            width: 157px;
            height: 158px;
            img {
                width: 100%;
            }
        }
        .current-container {
            width: 100%;
            position: absolute;
            height: 202px;
            bottom: 230px;
            .current-wraps {
                width: 582px;
                position: absolute;
                padding-left: 10px;
                .current-box {
                    width:100% !important;
                    margin-left: 20px;
                    img {
                        width: 100%;
                    }
                }
            }
        }
        .wrap {
            width: 690px;
            height: 647px;
            .swiper-wrapper {
                width:100% !important;
                img {
                    width: 100%;
                }
            }
        }
    }
    .ceiling-view {
        width: 100%;
        // height: 94px;
        // margin: 0px 0 40px;

        .ceiling-tab {
            position: relative;
            width: 100%;
            height: 94px;
            background: #FFFFFF;
            box-shadow: 0px 6px 8px 0px rgba(71, 68, 85, 0.08);
            z-index: 33;
            // /deep/ .van-tabs__wrap--scrollable{
            // height: 94px;
            // }
            .box {
                position: absolute;
                top: 0;
                right: 0;
                width: 60px;
                height: 94px;
                background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
            }
            /deep/ .van-tabs__nav {
                position: relative;
            }
            // /deep/ .van-tabs__wrap {
            //     height: 94px;
            // }
            /deep/ .van-tab {
                position: relative;
                width: 200px;
                height: 94px;
                color: #32355C;
                font-size: 30px;
                font-weight: 400;
            }
            /deep/.van-tab--active {
                box-sizing: border-box;
                color: #32355C;
                font-weight: 400;
                &::before{
                    content: '';
                    width: 32px;
                    height: 32px;
                    background: url('https://s20.lgstatic.com/growth/activity/20210923/1632364298791.png?x-oss-process=style/80') no-repeat center;
                    background-size: 100% 100%;
                    position: absolute;
                    left: 16px;
                    top:50%;
                    transform: translateY(-50%);
                    transition-duration: 0.3s;
                }
                .van-tab__text {
                    padding-left: 24px;
                }
            }
            /deep/ .van-tabs__line {
                // bottom: 40px;
                background: linear-gradient(309deg, #FF5A37 0%, #991010 100%);
                width: 160px;
                height: 6px;

            }
        }
        .ceiling-fixed {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 30;
        }
    }

    .layer {
        position: fixed;
        z-index: 9;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.6);
        display: none;
        &.active {
            display: block;
        }
    }
    .modal {
        position: fixed;
        bottom: 180px;
        z-index: 10;
        display: flex;
        justify-content: center;
        .modal-content {
            width: 750px;
            height: 0;
            opacity: 0;
            transition: height .3s linear;
            overflow-y: scroll;
            &.active {
                opacity: 1;
                height: 962px;
                overflow: hidden;
            }
            &.active-img {
                opacity: 1;
                height: 662px;
                overflow: hidden;
            }
            background: #fff;
            border-radius: 18px 18px 0 0;
            position: relative;
            margin-right: 45px;
            box-sizing: border-box;
        }
        .close {
            width: 42px;
            height: 42px;
            background: url("https://s21.lgstatic.com/growth/activity/20210402/1617356751440.png") no-repeat;
            background-size: 42px 42px;
            position: absolute;
            right: 30px;
            top: 30px;
            border-radius: 50%;
            z-index: 1;
        }
        .title {
            margin-top: 82px;
            width: 658px;
            font-size: 32px;
            line-height: 40px;
            margin-bottom: 41px;
            padding-left: 45px;
            font-weight: bold;
            &-dot {
                width: 5px;
                height: 5px;
                border-radius: 5px;
                background: #FA4000;
            }
            .sub-title{
                color: #C69C6D;
                font-size: 26px;
                margin-top: 8px;
            }
        }
        .content {
            height: 755px;
            overflow-y: scroll;
        }
        .content-title {
            margin-bottom: 20px;
            font-weight: bold;
            color: #191F34;
            position: relative;
            padding-left: 47px;
            font-size: 26px;
            line-height: 28px;
            padding-right: 30px;
            &:before {
                content: '';
                width: 8px;
                height: 8px;
                background: #C69C6D;
                border-radius: 8px;
                position: absolute;
                left: 25px;
                top: 11px;
            }
        }
        .content-desi {
            margin-bottom: 48px;
            color: #5E6476;
            font-size: 26px;
            padding-left: 48px;
            padding-right: 30px;
        }
        .content-img {
            width: 100%;
            height: 100%;
            overflow-y: scroll;
        }
        .content-img img{
            width: 100%;
            margin: 0px auto;
            display: block;
        }
    }
    .tips-box {
        position: absolute;
        top: 0px;
        left: 0;
        width: 100%;
        height: 100%;
        .tips-img {
            position: absolute;
            top: 0px;
            left: 0px;
            animation: left 2.2s infinite linear;
            display: block;
            height: 100%;
        }
    }
    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: -1px;
        z-index: 999;
        width: 100%;
        box-shadow: 0px -12px 12px 0px rgba(156, 157, 185, 0.22);
        .img {
            width: 100%;
            display: block;
        }
        .H5activityIcon {
            position: absolute;
            top: -50px;
            right: 42px;
            width: 209px;
        }
        .img-box {
            position: absolute;
            top: 10px;
            left: 0;
            width: 100%;
            height: 100px;
        }
        .img-btns {
            position: absolute;
            top: 0px;
            left: 0px;
            animation: left 2s infinite linear;
            width: 224px;
            height: 120px;
        }
    }

    @keyframes left {
        0% {
            left: -50%;
        }
        50% {
            left: 100%;
        }
        100% {
            left: 200%;
        }
    }
}


.txt-main {
    width: 100%;
    background: #f8f8f8;
    overflow: hidden;
    .title {
        width: 664px;
        height: 49px;
        display: block;
        margin: 30px 0 0 30px;
    }
}
.btn1 {
    height: 83px;
}
.btn2 {
    height: 118px;
}
.btn3 {
    height: 129px;
}
.btn4 {
    height: 92px;
}
.content {
    width: 694px;
    margin: 50px auto 0px;
}
/deep/ .tabViews {
    position: relative;
    width: 694px;
    border-radius: 11px;
    .tips-tab {
        position: absolute;
        bottom: 20px;
        right: 50px;
        color: #666;
        font-size: 14px;
    }
    .van-tabs__wrap--scrollable .van-tabs__nav {
        background: #FF9D69;
    }
    .van-tab {
        width: 150px;
        color: #fff;
        font-size: 26px;
        font-weight: 400;
    }
    .van-tabs--line .van-tabs__wrap {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    .van-tabs__line {
        background-color: #fff;
        bottom: 0.5rem;
        height: 4px;
    }
    .tb {
        width: 100%;
        padding-bottom: 80px;
        box-shadow: 0px 23px 37px 0px rgba(248, 115, 0, 0.09);
        background-color: #fff;
        border-radius: 0 0 11px 11px;
        .tb-title {
            font-size: 26px;
            font-family: SourceHanSansSC-Regular, SourceHanSansSC;
            font-weight: 400;
            color: #333333;
            text-align: center;
            padding-top: 30px;
        }
        .icon {
            width: 619px;
            height: 3px;
            display: block;
            margin: 18px auto 10px;
        }
        .tb-main {
            width: 100%;
        }
        .v-title {
            height: 37px;
            background: linear-gradient(180deg, #FFC492 0%, #FE6C11 100%);
            border-radius: 0px 18px 18px 0px;
            padding: 0 14px 0 30px;
            margin: 10px 0 20px;
            line-height: 37px;
            color: #fff;
            font-size: 21px;
            display: inline-block;
            font-family: SourceHanSansSC-Regular, SourceHanSansSC;
        }
        .tb-txt {
            box-sizing: border-box;
            width: 100%;
            color: #666;
            font-size: 21px;
            padding:4px 30px 4px;
        }
    }
}

.img-box {
    width: 100%;
    img {
        font-size: 0;
        display: block;
        width: 100%;
    }
    .activityImg {
        position: absolute;
        z-index: 11;
        top: 0;
        right: 0;
        width: 157px;
        height: 158px;
        img {
            width: 100%;
        }
    }
}
.swiper-main {
    width: 100%;
    background-size: 100% 100%;
    box-sizing: border-box;
    background: #f8f8f8;
}
.swiper-main0{
    background: url('https://s21.lgstatic.com/growth/activity/20211011/1633947769744.png') no-repeat;
    background-size: 100% 100%;
    height: 25.3rem;
    .current-wrap{
        top:80px;
        height: 85%;
    }
}
.swiper-main1{
    height: 7rem;
     .current-wrap{
        top:0px;
        height: 82%;
    }
}
.swiper-main2{
    height: 5rem;
}
.section-main {
    position: relative;
    width: 100%;
    margin-bottom: 100px;
    .stage-more {
        position: absolute;
        bottom: -45px;
        left: 50%;
        transform: translate(-50%);
        width: 422px;
        background-color:transparent;
        border: none;
        z-index: 9;
        overflow: hidden;
        .botton_img {
            width: 100%;
            display: block;
        }
    }
    .s-main {
        position: relative;
        margin: 0 auto;
        width: 688px;
        background-color: #fff;
        z-index: 2;
        border-radius: 8px;
        padding-bottom: 150px;
        box-shadow: 0px 2px 15px 0px rgba(225, 225, 225, 0.73);
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        overflow: hidden;
        .tb {
            position: relative;
            width: 100%;
            background-color: #fff;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            overflow: hidden;
            .t-title {
                text-align: center;
                font-size: 32px;
                color: #555555;
                font-weight: 500;
                padding: 25px 0 10px;
            }
            .t-icon {
                width: 688px;
                display: block;
                height: 2px;
            }
            .target {
                color: #3D3D3F;
                font-size: 26px;
                margin-top: 35px;
                .title {
                    position: relative;
                    display: flex;
                    height: 49px;
                    align-items: center;
                    font-weight: bold;
                }
                .title1 {
                    margin-top: 38px;
                }
                .tips{
                    width: 6px;
                    height: 22px;
                    margin-left: 40px;
                    background: linear-gradient(82deg, #FF8645 0%, #FF1E3A 100%);
                }
                .text-title {
                    height: 46px;
                    border-radius: 30px;
                    text-align: center;
                    margin-left: 14px;
                    line-height: 46px;
                }
                .text {
                    flex: 1;
                }
                .btn {
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 151px;
                    height: 49px;
                    background: url('https://s20.lgstatic.com/growth/activity/20211011/1633932880073.png?x-oss-process=style/80') no-repeat;
                    background-size: 100% 100%;
                    margin-right: 40px;
                }
                .content {
                    margin-top: 10px;
                }
                .content-list {
                    display: flex;
                    color: #595959;
                    line-height: 48px;
                    font-size: 24px;
                    .icon {
                        width: 8px;
                        height: 8px;
                        background: #565659;
                        border-radius: 50%;
                        margin-left: 46px;
                        margin-top: 20px;
                        margin-right: 8px;
                    }
                    .white-bg{
                        background: #fff;
                    }
                    .text {
                        opacity: .7;
                        flex: 1;
                        width: 612px;
                        padding-right: 14px;
                    }
                }
                .content-list:last-child {
                    .icon {
                        // background: #fff;
                    }
                }
            }
        }
        .tips-tab {
            position: absolute;
            bottom: 80px;
            right: 40px;
            color: #666;
            font-size: 12px;
        }

    }
    /deep/ .van-tabs__wrap--scrollable{
        height: 106px;
    }
    /deep/ .van-tabs__nav {
        background: linear-gradient(90deg, #0F60C6 0%, #0A015F 100%);
        height: 106px;
    }
    /deep/ .van-tabs--line .van-tabs__wrap {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    /deep/ .van-tab {
        width: 200px;
        height: 106px;
        color: #fff;
        font-size: 28px;
        font-weight: 400;
    }
    /deep/ .van-tabs__line {
        bottom: 40px;
        background: #fff;
        width: 64px;
        height: 6px;
    }
}
/deep/ .current-wrap {
    width: 8.507rem;
    height: 100%;
    .swiper-wrapper {
        width: 8.507rem;
        height: 100%;
        .swiper-slide {
            width: 100%;
            height: 100%;
            img {
                width: 100%;
            }
        }
    }
    .swiper-pagination-bullet{
        width: 0.173rem;
        height: 0.173rem;
        background: #ffd1aa;
        border-radius: 50%;
        margin: 0 3px;
        opacity: 1;
        &-active{
            border-radius: 0.173rem;
            width: 0.38rem;
            background: #F07234;
        }
    }
}
/deep/ .swiper-main0 {
    .swiper-container-horizontal>.swiper-pagination-bullets{
        bottom: 20px;
    }
}
/deep/ .swiper-main1 .swiper-pagination-bullet{
    bottom: 20px !important;
    background: #D6D6D6 !important;
     &-active{
            background: linear-gradient(250deg, #FF5325 0%, #EB0505 100%) !important;
    }
}
/deep/ .swiper-main2 .swiper-pagination-bullet{
    bottom: 20px !important;
    background: #D6D6D6 !important;
     &-active{
            background: linear-gradient(250deg, #FF5325 0%, #EB0505 100%) !important;
    }
}

#section_26 .btn-style{
    bottom: 60px;
}
</style>
